import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../../../details/general-details/AppTextColumnDetails'

const AppModalDetails = ({
  supportingLinkDetails
}) => {
  return (
    <>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="12"
          title="Url"
          className='mb-3'
          subtitle={supportingLinkDetails?.file_url}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Name"
          className='mb-3'
          subtitle={supportingLinkDetails?.file_name}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Description"
          className='mb-3'
          subtitle={supportingLinkDetails?.file_description}
        />
      </CRow>
    </>
  )
}

export default AppModalDetails
